Ext.define('SA.model.LocationValue.CustomCacheConformant', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            var object = SA.Object.of(value),
                isRadius = () => object.hasType('radius') && object.keysAre(SA.data.CustomLocations.RadiusItemKeys),
                isCombo = () => object.hasType('combination') && object.keysAre(SA.data.CustomLocations.ComboItemKeys);

            return object && (isRadius() || isCombo());
        }
    },

    getId() {
        return this.value.id;
    }
});